import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/auth/password/sign-in']['POST'];
type Output = ThisApi['response'];
type Input = ThisApi['body'];

const passwordSignIn = async (payload: Input): Promise<Output> => {
  const response = await noodleApiClient.post('/auth/password/sign-in', payload);
  return response.data;
};

export default passwordSignIn;
